export enum STORAGE_KEY {
  SEARCH_HISTORY = 'searchHistory',
  EASY_CERTIFICATION = 'easyCertification',
  KOSAF_PROCESS = 'kosafProcess',
  JEJU_YOUTHDREAM = 'jejuYouthdream',
  NICE_FORM_VALUES = 'niceFormValues',
  LOGOUT_TOAST = 'logoutToast',
  POLICY_FILTER_LANDING = 'policyFilterLanding',
  POLICY_FILTER_LANDING_FROM = 'policyFilterFrom',
  POLICY_FILTER = 'policyFilter',
  HOMETOWN_NEWS_DETAIL_BOTTOM_DRAWER_PATH = 'hometownNewsDetailBottomDrawerPath',
  MY_INFO_PROFILE_SCRAP_ACTIVE_TAB = 'myInfoProfileScrapActiveTab',

  //* 회원 가입시 어떤 사용자가 추천했는지를 구분할 수 있는 코드
  MEMBER_CODE = 'memberCode',

  //* 회원가입 이벤트 로그를 위한 정보
  SIGNUP_METHOD = 'signupMethod',
  SIGNUP_TYPE = 'signupType',
  //* 로그인 진행 중 여부
  IS_LOGIN_PROGRESS = 'isLoginProgress',

  //* 웰퍼 신청 프로세스 중에 임시로 저장해 놓는 정책 분야 태그들
  WELLPER_APPLY_POLICY_TEMP_VALUES = 'wellperApplyPolicyTempValues',

  //* 럭키볼 관련
  OPEN_ONCE_LUCKY_BALL_MODAL_BY_HOME = 'openOnceLuckyBallModalByHome',
  SHOW_ONCE_GET_LUCKY_BALL_TOAST_BY_MY_LUCKY_BALL = 'showOnceGetLuckyBallToastByMyLuckyBall',

  //* history 관련 정보
  HISTORY = 'history',
  HISTORY_EXPIRE = 'historyExpire',
  HISTORY_INDEX = 'historyIndex',
  REPLACE_MARK = 'replaceMark',
  REPLACE_MARK_KB = 'replaceMarkKb',

  //* 홈 피드 쿼리 복원 상태
  HOME_FEED_QUERY_STATE = 'homeFeedQueryState',
  //* 타임라인 스크롤 히스토리 (섹션별 스크롤 + expanded 상태)
  TIMELINE_SCROLL_HISTORY = 'timelineScrollHistory',

  //* 답례품 상세 페이지 방문 기록
  GIFT_VISIT = 'giftVisit',

  //* 답례품 최근 검색어
  GIFTS_SEARCH_RECENT_KEYWORDS = 'giftsSearchRecentKeywords',

  //* 비회원 세션 아이디
  GUEST_SESSION_ID = 'guestSessionId',

  //* 전역 팝업 마지막 노출 정보
  GLOBAL_POPUP_EXPOSURE = 'globalPopupExposure',

  //* 고향사랑기부 홈 지자체 답례품 목록 선택한 지자체 아이디
  DONATION_HOME_SELECTED_SPECIALTY_INSTITUTION_ID = 'donationHomeSelectedSpecialtyInstitutionId',

  //* 첫 기부 시 약관 동의 여부
  DONATION_AGREEMENT = 'donationAgreement',

  //* 답례품 문의하기로 문의하기 페이지로 이동했는지 여부
  IS_DONATION_INQUIRY_BY_GIFT_PRODUCT = 'donationInquiryByGiftProduct',
}

export namespace STORAGE_TYPE {
  export type HISTORY = [number, string][];
}
